<template>
  <div>
    <CCardBody class="py-0 pl-2 pr-0">
      <table class="table mb-0">
        <tbody>
          <div
            class="custom-width-total"
            v-for="(r, index) in productos.filter(
              prod => prod.payload.pertenece_id == productoPadre
            )"
            :key="index"
          >
            <tr class="custom-width-total">
              <td
                @click="toggleSubProductos(index)"
                class="custom-width"
                :class="
                  `${
                    productos.filter(p => p.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                <span>
                  <CIcon
                    v-if="
                      productos.filter(p => p.payload.pertenece_id == r.id)
                        .length > 0
                    "
                    name="cil-chevron-circle-down-alt"
                  />
                </span>
                {{ r.payload.nombre }}
              </td>
              <td
                @click="toggleSubProductos(index)"
                class="custom-width"
                :class="
                  `${
                    productos.filter(p => p.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{ r.payload.unidad }}
              </td>

              <td class="custom-width5">
                <router-link
                  :to="{
                    name: 'EditarProducto',
                    params: { id: r.id }
                  }"
                >
                  <CButton color="success" square size="sm">Editar</CButton>
                </router-link>
              </td>
              <td class="custom-width5">
                <CButton
                  :disabled="
                    productos.filter(p => p.payload.pertenece_id == r.id)
                      .length > 0
                      ? true
                      : false
                  "
                  color="danger"
                  square
                  size="sm"
                  @click="toggleCancel(index, r)"
                  >Borrar</CButton
                >
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  productos.filter(p => p.payload.pertenece_id == r.id).length >
                    0
                "
                class="py-0 pl-2 pr-0"
                colspan="4"
              >
                <CCollapse
                  :show="subDetails.includes(index)"
                  class="m-0 custom-width-total"
                >
                  <table-collapse-products
                    @click-cancel="toggleCancel"
                    :productoPadre="r.id"
                    :productos="productos"
                  ></table-collapse-products>
                </CCollapse>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
export default {
  name: "TableCollapseProducts",

  props: {
    productos: {
      type: Array
    },
    productoPadre: {
      type: Number
    }
    // actualIndex: {
    //   type: Number
    // }
  },

  // computed: {
  //   nextIndex() {
  //     return this.actualIndex + 1;
  //   },

  //   lastIndex() {
  //     return this.productos.length - 1;
  //   },
  //   item() {
  //     return this.productos[this.actualIndex];
  //   },
  //   productoAct() {
  //     return this.productoActual;
  //   }
  // },

  data() {
    return {
      details: [],
      subDetails: [],
      disabledCancel: true,
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapseProducts: () => import("./TableCollapseProducts.vue")
  },

  methods: {
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    toggleSubProductos(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
